const testimonials = [
  {
    name: "Rachel G.",
    location: "Parkland, FL — Heron Bay",
    rating: 5,
    text: "Our daughter's bat mitzvah trip to Israel was scheduled for June, and I discovered in April that her passport had expired two months earlier. We had non-refundable flights, hotel bookings in Jerusalem, and family meeting us from three states. Fast Passport Center processed her renewal in five business days. They understood the religious significance of the timeline and treated our case with genuine urgency. We made the trip without a single issue.",
    service: "Child Passport Renewal",
  },
  {
    name: "David M.",
    location: "Parkland, FL — Parkland Golf & Country Club",
    rating: 5,
    text: "I booked a family cruise from Port Everglades for spring break with three weeks of notice. Checked our passports the night I booked and realized my son's had expired four months ago. Fast Passport Center walked me through the child passport process, I shipped everything from the UPS Store in Coral Springs, and his passport arrived four days before we sailed. They literally saved our vacation.",
    service: "Child Passport",
  },
  {
    name: "Jennifer S.",
    location: "Parkland, FL — Pine Tree Estates",
    rating: 5,
    text: "My husband and I had a trip to Paris planned for our 20th anniversary. Two weeks before departure, I pulled my passport out of the safe and the cover was water-damaged from a minor leak we had months ago. I had no idea a damaged passport could ground you. Fast Passport Center processed a replacement in three business days. We made our anniversary dinner at a restaurant overlooking the Seine. I will never forget what they did for us.",
    service: "Damaged Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function ParklandTestimonialsSection() {
  return (
    <section id="testimonials" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Parkland Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Parkland residents across Heron Bay, Parkland Golf &amp; Country Club, Pine Tree Estates, and surrounding northern Broward County communities who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}